import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import UserDetailsComponent from "../../components/UserDetailsComponent";
import { FaArrowLeft } from "react-icons/fa6";
import SuggestedClubs from "../../components/SuggestedClubs";
import LatestNews from "../../components/LatestNews";
import Nav from 'react-bootstrap/Nav';
import PostList from "../../components/Post";




function UserDetails() {
  const [activeTab, setActiveTab] = useState("option1"); // Default tab
  const location = useLocation();
  const navigate = useNavigate();
  // Retrieve user data from state
  const user = location.state?.user;

  // If no club data is found, show an error message
  if (!user) {
    return <h2>User Not Found</h2>;
  }

  return (
    <div className="club-details">
      <div className="club-post-section">
        {/* Back Button */}
        <div className="back-button" onClick={() => navigate(-1)}>
          <span><FaArrowLeft className="back-icon" /></span> <h2>Users</h2>
        </div>
        {/* user Details */}
        <UserDetailsComponent />
        {/* Navigation Tabs */}
        <Nav variant="pills" activeKey={activeTab} onSelect={(selectedKey) => setActiveTab(selectedKey)}>
          <Nav.Item>
            <Nav.Link eventKey="option1">Posts & Polls</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="option2">Events</Nav.Link>
          </Nav.Item>
        </Nav>

        {/* Tab Content */}
        <div className="tab-content mt-3">
          {activeTab === "option1" && <div>
            <PostList filterByType={["post", "poll"]} />
          </div>}
          {activeTab === "option2" && <div>
            <PostList filterByType="event" />
          </div>}
        </div>
      </div>
      <div className="right-side-bar">
        <LatestNews />
        <SuggestedClubs />
      </div>
    </div>
  );
};

export default UserDetails;


